import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, FolderKanban, Plus } from 'lucide-react';
import EmptyState from '@/components/EmptyState';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { formatDate } from '@/lib/format';
import { TEST_IDS } from '@/constants/testIds/alvora';

// Last five projects (from the Command Centre projects source — no extra query). Moved from the former Dashboard.
export function RecentProjects({ projects, orgName, error }) {
  const recent = [...projects].sort((a, b) => (b.created_at || '').localeCompare(a.created_at || '')).slice(0, 5);
  return (
    <div className="rounded-lg border border-border bg-white" data-testid="cc-recent-projects">
      <div className="flex items-center justify-between px-5 py-4 border-b border-border">
        <div>
          <h2 className="font-display font-semibold text-base text-charcoal">Recent projects</h2>
          <p className="text-xs text-muted-foreground mt-0.5">The last five projects created for {orgName || 'your organisation'}.</p>
        </div>
        <Link to="/projects" className="text-xs text-bronze hover:text-bronze-hover transition-colors duration-150">View all →</Link>
      </div>
      {error ? <div className="p-6 text-sm text-red-700">Could not load projects: {error}</div>
        : recent.length === 0 ? (
          <div className="p-6"><EmptyState icon={FolderKanban} title="No projects yet" description="Create your first project to start tracking budgets, costs and progress."
            action={<Link to="/projects"><Button data-testid={TEST_IDS.createFirstProject} className="bg-bronze hover:bg-bronze-hover text-white transition-colors duration-150"><Plus size={16} className="mr-1.5" /> Create first project</Button></Link>} /></div>
        ) : (
          <ul className="divide-y divide-border">
            {recent.map((p) => (
              <li key={p.id} className="group">
                <Link to={`/projects/${p.id}`} data-testid={`cc-recent-project-${p.id}`} className="flex items-center gap-4 px-5 py-3 hover:bg-muted/50 transition-colors duration-150">
                  <div className="h-9 w-9 rounded-md bg-warmgrey-soft text-warmgrey flex items-center justify-center flex-shrink-0"><Building2 size={16} /></div>
                  <div className="min-w-0 flex-1">
                    <div className="font-medium text-sm text-charcoal truncate">{p.name || p.project_code || 'Untitled project'}</div>
                    <div className="text-xs text-muted-foreground truncate">{p.project_code ? `#${p.project_code}` : '—'}{p.created_at ? ` · ${formatDate(p.created_at)}` : ''}</div>
                  </div>
                  {p.status && <Badge variant="outline" className="text-[11px] uppercase tracking-wider">{p.status}</Badge>}
                  <ArrowRight size={14} className="text-muted-foreground group-hover:text-bronze transition-colors duration-150" />
                </Link>
              </li>
            ))}
          </ul>
        )}
    </div>
  );
}
